import Grid from '@material-ui/core/Grid';
import Hidden from '@material-ui/core/Hidden';
import withWidth from '@material-ui/core/withWidth';
import type { MouseEventHandler } from 'react';
import React, { Component } from 'react';

import { MyTableContext } from '..';
import styles from '../styles';

//TODO ACHAR INTERFACE
interface IProps {
  screenSizes?: any;
  colSpan?: any;
  numeric?: boolean;
  mobileOrder?: number;
  status?: any;
  className?: any;
  style?: any;
  styles?: any;
  action?: any;
  width?: any;
  responsive?: boolean;
  classes?: any;
  onClick?: MouseEventHandler<HTMLTableDataCellElement>;
}

class MyTableCol extends Component<IProps, any> {
  static defaultProps: Partial<IProps> = {
    screenSizes: [],
  };

  hiddenField = (): 'xs' | 'sm' | 'md' | 'lg' | any[] => {
    let hiddens = [];
    for (let k in this.props.screenSizes) {
      if (this.props.screenSizes[k] === 0) {
        hiddens.push(k);
      }
    }
    return hiddens;
  };

  render() {
    const { classes, width, responsive, onClick } = this.props;

    if (!responsive || width === 'md' || width === 'lg' || width === 'xl') {
      return (
        <td
          colSpan={this.props.colSpan}
          className={
            classes.td +
            (this.props.numeric ? ' numeric' : '') +
            (this.props.status ? ' status' : '') +
            ' ' +
            (this.props.className ? this.props.className : '')
          }
          style={this.props.style}
          onClick={onClick}
        >
          {this.props.children}
        </td>
      );
    }

    return (
      <Hidden only={this.hiddenField()}>
        <Grid
          item={true}
          style={{ order: this.props.mobileOrder ? this.props.mobileOrder : 'initial', ...this.props.styles }}
          className={
            classes.tdCard +
            (this.props.numeric ? ' numeric' : '') +
            (this.props.action ? ' action' : '') +
            (this.props.status ? ' status' : '') +
            ' ' +
            this.props.className
          }
          xs={this.props.screenSizes['xs']}
          sm={this.props.screenSizes['sm']}
          md={this.props.screenSizes['md']}
          lg={this.props.screenSizes['lg']}
          onClick={onClick}
        >
          {this.props.children}
        </Grid>
      </Hidden>
    );
  }
}

export default withWidth()(
  styles(
    React.forwardRef((props: IProps, ref: any) => (
      <MyTableContext.Consumer>{(context) => <MyTableCol {...props} {...context} ref={ref} />}</MyTableContext.Consumer>
    ))
  )
);
